import { Component, OnInit, OnDestroy } from '@angular/core';
import { SeedTreatmentSearchRequest, TankmixTest } from '../../models/searchRequest';
import { ApiService } from '../../services/api.service';
import { PreferencesService } from '../../services/preferences.service';
import { ReferenceDataService } from '../../services/reference-data.service';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NamedId } from '../../models/NamedId';
import { Subscription, forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SearchHistoryService } from '../../services/search-history.service';
import { KindPage } from '../../enums/kind-page';
import { ActivatedRoute } from '@angular/router';
import { SearchRequestHistoryItem } from '../../models/searchRequestHistoryItem';
import { CountryRedirectService } from '../../services/country-redirect.service';

@Component({
  selector: 'app-search-seed-treatment',
  templateUrl: './search-seed-treatment.component.html'
})
export class SearchSeedTreatmentComponent implements OnInit, OnDestroy {
  faFilePdf: any = faFilePdf;
  previousSearches: SeedTreatmentSearchRequest[] = [];
  showIntroduction: boolean = true;
  countryChoices: NamedId[] = [];
  yaraProductChoices: NamedId[] = [];
  activeIngredientChoices: NamedId[] = [];
  agrochemicalChoices: NamedId[] = [];
  cropChoices: NamedId[] = [
    { id: '1', name: 'Wheat' },
    { id: '2', name: 'Barley' },
    { id: '3', name: 'Oats' },
  ];
  results: TankmixTest[] = null;
  /* search: SeedTreatmentSearchRequest = {
     countryCode: null,
     seedName: null,
     benefitName: null
 
   };*/
  searching: boolean;
  choicesSubscription: Subscription;
  preferencesSub: Subscription;
  searchForm: UntypedFormGroup;
  countryChosen: boolean;
  searchHistoryItem: SearchRequestHistoryItem;
  languageCode: string;
  
  constructor(private api: ApiService,
    private preferences: PreferencesService,
    private refData: ReferenceDataService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute, 
    private preferencesService: PreferencesService,
    private searchHistory: SearchHistoryService,
     private countryRedirect: CountryRedirectService 
  ) {
    this.showIntroduction = true;
    this.searchForm = this.fb.group({
      countryCode: [null],
      seedName: [null],
      benefitName: [null],
      yaraProductCode: [null]
    });
    this.preferencesService.languageCode$.subscribe(
      (code) => (this.languageCode = code)
    );
  }
  ngOnDestroy(): void {
    this.choicesSubscription?.unsubscribe();
    this.preferencesSub?.unsubscribe();
  }

  ngOnInit() {
    // this.preferencesSub = this.preferencesService.countryCode$.subscribe(countryCode => {
    //   this.searchForm.patchValue({ countryCode: countryCode });
    //   this.countryChosen = countryCode != null;
    

     // this.countryRedirect.redirectByLangOrCountry(this.languageCode, countryCode);


      //this.changeCountry();
    // });
    //this.searchForm.patchValue({ countryCode }, { emitEvent: false });

    this.searchForm.valueChanges.subscribe(values => {
      if (values.countryCode != null) {
        this.countryChosen = true;
        this.preferencesService.countryCode = values.countryCode;

        // this.countryRedirect.redirectByLangOrCountry(this.languageCode, values.countryCode);
      }
    })
    this.choicesSubscription = forkJoin(
      this.refData.getCountries())
      .pipe(tap((data: any) => {

        this.countryChoices = data[0];
    
      })
      ).subscribe();

       // check if page comes from search history component
       let index = this.route.snapshot.params.id;
       if (index != undefined) {
        this.searchHistoryItem = this.searchHistory.getHistoryItem(index);
        if (this.searchHistoryItem  == undefined) {return;}
        this.pathFormWithSearchCriteria();
       }
  }

  pathFormWithSearchCriteria() {
    var criteria = this.searchHistoryItem.criteria;
    this.searchForm.patchValue(criteria);
    this.performSearch();
  }
  searchAgain() {
    this.results = null;
  }
  resetSearch() {
    this.searchForm.patchValue({ sedName: null, benefitName: null, yaraChemicalId: null });
  }

  toggleIntroduction() {
    this.showIntroduction = !this.showIntroduction;
  }
  changeCountry() {
    //this.refData.setCountry(this.searchForm.value.countryCode).subscribe(x => { this.yaraProductChoices = x; });
    const code: string = (this.searchForm.value.countryCode || '').toLowerCase();
  // redirect based on language or country
   // this.countryRedirect.redirectByLangOrCountry(this.languageCode, code);

    this.refData.setCountry(code).subscribe(x => { this.yaraProductChoices = x; });
  }
  performSearch() {
    this.searching = true;
    console.log(this.searchForm.value);
    

    let val = this.searchForm.value;
    this.api.searchSeedTreatments({
      countryCode:  val.countryCode,
      yaraProductCode: val.yaraProductCode?.id,
      languageCode: this.languageCode
    }).subscribe((x: TankmixTest[]) => {
      this.results = x;
      this.searching = false;

        // store result in local storage
      this.storeSearchCriteria(this.searchForm.value, x.length);
    });
  }

  private storeSearchCriteria(criteria: any, numberOfResults: number) {
    console.log(criteria);
    this.searchHistory.storeSearchCritera(criteria,numberOfResults, KindPage.SeedCoating);
  }
  convertedAppRate(inp:number)
  {
    return this.preferencesService.convertApplicationUnits(inp);
  }
  convertedWaterRate(inp:number)
  {
    return this.preferencesService.convertWaterUnits(inp);
  }
  convertedSeedRate(inp: number) {
    return this.preferencesService.convertSeedUnits(inp);
  }
}
